import { render, staticRenderFns } from "./teamFormation.vue?vue&type=template&id=736da71c&scoped=true"
import script from "./teamFormation.vue?vue&type=script&lang=js"
export * from "./teamFormation.vue?vue&type=script&lang=js"
import style0 from "./teamFormation.vue?vue&type=style&index=0&id=736da71c&prod&lang=scss"
import style1 from "./teamFormation.vue?vue&type=style&index=1&id=736da71c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736da71c",
  null
  
)

export default component.exports